import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {setCommonInputs} from "../../redux/reducers/common";
import {
    Account,
    AddCustomer,
    AddFindings, AddFindingsToThisAsset,
    Logout,
    MyTeam,
    SeeScope, SlackButton,
    StartNewPentest,
    UpdatePentestLandScapeButton,
    StartNewEASM,
    StartNewGenPT,
    StartNewVA
} from "./Menu";
import {Divider} from "@mui/material";
import {PermissionProvider} from "../../hoc/withPermissions";
import {SIEMBA_ADMIN, SIEMBA_CUSTOMER, SIEMBA_CUSTOMER_ENGINEER, SIEMBA_TESTER} from "../../utils/roles";
import {SLACK_CLIENT_ID} from "../../utils/constants";
import {useValidateLogin} from "../../hooks/auth";
import {useCustomerDetails} from "../../hooks/customer";
import Modal from '../MuiComponents/Modal';
import { useAppMode } from '../../Providers/AppModeProvider';
import Button from '../Button';
import GlobalCompanySelection from '../Inputs/GlobalCompanySelection';

const ExpandedMenu = () => {
    const {data} = useValidateLogin()
    const {data: customer, isFetching} = useCustomerDetails(data?.user?.user_type === 'customer')
    const { isMenuExpanded } = useSelector((state) => state.common);
    const [startAssessmentModal, setStartAssessmentModal] = useState(false);

    const dispatch = useDispatch();

    const handleStartAssessmentClick = () => {
      setStartAssessmentModal(true);
      closeExpandedMenu();
    };

    const handleCancelStartAssessment = () => {
      setStartAssessmentModal(false);
    };

    const closeExpandedMenu = () => {
      dispatch(setCommonInputs({
        isMenuExpanded: false
      }));
    }

    const { APP_MODE } = useAppMode();

    return (
      <>
        {isMenuExpanded && (
          <div
            className="absolute w-full h-screen z-0 inset-0"
            onClick={() => closeExpandedMenu()}
          />
        )}
        <Modal
          open={startAssessmentModal}
          onClose={handleCancelStartAssessment}
          maxWidth="md"
          PaperProps={{ className: '!min-w-[300px]' }}
        >
          <div className="pt-6 px-2 text-center">
            {/* <Typography variant="body1" className="text-gray-700 mb-6"> */}
            <h7>
              Select the assessment type
            </h7>
            {/* </Typography> */}
            <div className="flex flex-col lg:flex-row justify-center gap-2 p-3 !text-[13px] lg:!text-[16px]">
              <StartNewEASM key="easm" disabled={APP_MODE === 'genptbeta'}/>
              <Divider orientation={"horizontal"} flexItem/>
              <StartNewVA key="va" disabled={APP_MODE === 'genptbeta'} className='!text-[13px]'/>
              <Divider orientation={"horizontal"} flexItem/>
              <StartNewGenPT key="genpt" from="header" />
              <Divider orientation={"horizontal"} flexItem/>
              <StartNewPentest key="pentest" disabled={APP_MODE === 'genptbeta'} />
            </div>
          </div>
        </Modal>
        <div className="relative z-50">
            <div className={"flex flex-col pl-2 pr-3 py-3 ml-2 gap-2 !text-[12px] lg:!text-[16px]"}>
                <div className={"flex-1"}>
                    <Account/>
                </div>
                <div className='my-2'>
                  <Divider orientation={"horizontal"} flexItem/>
                </div>
                <GlobalCompanySelection />
                <div className='my-2'>
                  <Divider orientation={"horizontal"} flexItem/>
                </div>
                <PermissionProvider roles={[SIEMBA_ADMIN]}>
                  <div onClick={closeExpandedMenu} className="flex flex-col">
                    <AddCustomer className={"my-1"}/>
                  </div>
                </PermissionProvider>
                <PermissionProvider roles={[SIEMBA_CUSTOMER, SIEMBA_ADMIN]}>
                  <Button
                    variant="outlined"
                    onClick={handleStartAssessmentClick}
                  >
                    START ASSESSMENT
                  </Button>
                </PermissionProvider>
                <PermissionProvider roles={[SIEMBA_ADMIN]}>
                  <div onClick={closeExpandedMenu}>
                    <MyTeam className={"my-1"}/>
                  </div>
                </PermissionProvider>
                <div className='my-2'>
                  <Divider orientation={"horizontal"} flexItem/>
                </div>
                <div className={"mt-1 flex-1"}>
                    <Logout/>
                </div>
            </div>
            <PermissionProvider roles={[SIEMBA_TESTER]}>
              <div onClick={closeExpandedMenu}>
                <AddFindingsToThisAsset className={"my-1"}/>
              </div>
            </PermissionProvider>
            <PermissionProvider roles={[SIEMBA_TESTER]}>
              <div onClick={closeExpandedMenu}>
                <AddFindings className={"my-1"}/>
              </div>
            </PermissionProvider>
            <PermissionProvider roles={[SIEMBA_CUSTOMER_ENGINEER, SIEMBA_CUSTOMER]}>
              <div onClick={closeExpandedMenu}>
               <SeeScope className={"my-1"}/>
              </div>
            </PermissionProvider>
            <PermissionProvider roles={[SIEMBA_CUSTOMER]}>
              <div onClick={closeExpandedMenu}>
                <UpdatePentestLandScapeButton className={"my-1"}/>
              </div>
                {/* {(SLACK_CLIENT_ID && !isFetching && !customer?.slackConnectionId) && <SlackButton className={"my-1"}/>} */}
            </PermissionProvider>
            <PermissionProvider roles={[SIEMBA_CUSTOMER]}>
              <div onClick={closeExpandedMenu}>
                <StartNewPentest className={"my-1"}/>
              </div>
            </PermissionProvider>
        </div>
      </>
    );
};

export default ExpandedMenu;
